import * as React from 'react';

import { FormContext, FormContextProps } from '../shared';


function withFormContext<P,S>(WrappedComponent: React.ComponentType<P>): React.SFC<P> {
	const EnhancedComponent: React.SFC<P> = (props: P) => (
		<FormContext.Consumer>
			{(ctx: FormContextProps<S>) => {
				return (
					<WrappedComponent
						{...props}
						isFetching={ctx.isFetching}
						getFormObject={ctx.getFormObject}
						setFormObject={ctx.setFormObject}
						addValidationRule={ctx.addValidationRule}
						removeValidationRule={ctx.removeValidationRule}
						getErrorValidationRule={ctx.getErrorValidationRule}
						sortValidationRulesByPriority={ctx.sortValidationRulesByPriority}
						submitForm={ctx.submitForm}
						validateForm={ctx.validateForm}
						scrollContainer={ctx.scrollContainer}
					/>
				);
			}}
		</FormContext.Consumer>
	);

	return EnhancedComponent;
}

export default withFormContext;
